import React from "react";
import { Fragment } from "react";

export default function SmsHeader() {
  return (
    <Fragment>
      <div className="row customers">
        <div className="col-sm-12">
          <h2>SMS Setting</h2>
        </div>
      </div>
    </Fragment>
  );
}